import loadable from "@loadable/component";
export { default as useDeadlineDetails } from "./useDeadlineDetails";
export const Deadline = loadable(()=>import(/* webpackChunkName: "Deadline" */ "./Deadline"), {
    ssr: false
});
